export function initFittyText() {
    if (document.querySelector('.js-fitty-wrapper')) {
        import('./fitty_logic.js')
            .then(module => module.default())
            .catch(err => console.error("Errore Fitty Logic:", err));
    }
}
